import type { IGetUserProfileResponse } from "@tiendeo/auth/dist/AuthApi/Controllers/User/Entities/IGetUserProfileResponse";
import useProfileQuery from "queries/useProfileQuery";
import { useMemo } from "react";

const profileCompletionSteps: (keyof IGetUserProfileResponse)[] = [
    "name",
    "phoneVerified",
    "birthDay",
    "zipCode",
    "genre",
    "pets",
    "familyAdults",
];

const useProfileCompletion = () => {
    const { data: user } = useProfileQuery();

    const steps = useMemo(
        () => profileCompletionSteps.filter((step) => step !== "phoneVerified"),
        [],
    );

    return useMemo(() => {
        return {
            value: !!user
                ? steps.reduce((stepsCompleted, key) => {
                      const noFamily =
                          key === "familyAdults" && !user?.familyAdults && !user?.familyKids;
                      const noPets = key === "pets" && (user?.pets || []).length === 0;
                      const noOther = key !== "familyAdults" && key !== "pets" && !user[key];

                      if (noFamily || noPets || noOther) {
                          return stepsCompleted;
                      }

                      stepsCompleted++;
                      return stepsCompleted;
                  }, 0)
                : 0,
            max: steps.length,
        };
    }, [user, steps]);
};

export default useProfileCompletion;
